export default __webpack_public_path__ + "static/media/zoom-out-fixed.4fd2b308.png";